export const SET_WALK_TEST_MODAL = 'SET_WALK_TEST_MODAL';
export const SET_WALK_TEST_FORM_DATA = 'SET_WALK_TEST_FORM_DATA';
export const CLEAR_WALK_TEST_FORM_DATA = 'CLEAR_WALK_TEST_FORM_DATA';

export const setWalkTestModal = (isOpen) => ({
  type: SET_WALK_TEST_MODAL,
  payload: isOpen
});

// Add action to store form data when going back
export const setWalkTestFormData = (formData) => ({
  type: SET_WALK_TEST_FORM_DATA,
  payload: formData
});

// Add action to clear form data when flow completes
export const clearWalkTestFormData = () => ({
  type: CLEAR_WALK_TEST_FORM_DATA
});
